<div class="container">
  <h2 class="title text-center">Tabela de Convergência</h2>

  <p class="text-justify">
    Nesta página, apresentamos a tabela de convergência, ou seja, os cursos que tiveram suas denominações alteradas em relação às edições anteriores do Catálogo. A tabela de convergência relaciona as denominações de Cursos Superiores de Tecnologia que não estão mais em uso com os cursos constantes nesta edição do Catálogo.
  </p>
  <p class="text-justify">
    Ressalta-se que a convergência proposta deve ser utilizada como um referencial, pois somente um
    exame detalhado do projeto pedagógico do curso, por parte da escola, poderá definir qual dentre
    as denominações presentes no Catálogo é a mais conveniente para a conversão.
  </p>
  <br />
  <a
    routerLink="/cursos"
    [queryParams]="{ filtro: 'mudaramnome' }"
    class="btn-primary link btn btn-xl rounded-pill text-center"
    >Ir para esses cursos</a
  >
</div>
